export function makeQueryParams(object: any) {
  let value = []
  for (let key in object) {
    value.push(`&${key}=${object[key]}`);
  }
  let last: string = value.join('').split(',').toString();
  return  last.substring(1);
}